import { IDictionaryValue } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { IDictionaryValues } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValues';

import { IDictionarySelectOption } from '../interfaces/IDictionarySelectOption';

export const makeCreateErvkCheckListSelectOption = <ValueType>(
  idProp: keyof ValueType,
  labelProp1: keyof ValueType,
  labelProp2: keyof ValueType,
) => (
  dictionaryId: IDictionaryValues<ValueType>['idDictionary'],
  dictionaryValue: IDictionaryValue<ValueType>,
): IDictionarySelectOption<ValueType> => ({
  ...dictionaryValue.value,
  id: dictionaryValue.value[idProp],
  label: `${dictionaryValue.value[labelProp1]} - ${dictionaryValue.value[labelProp2]}`,
  value: {
    dictId: dictionaryId,
    dictVersionId: dictionaryValue.idValue,
  },
});
